import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { Drawer, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { map, isNull } from 'underscore';
import { getBaseUrl } from '../../../core/utils/api';
import whiteLogo from '../../../assets/images/logo-white.webp';
import { MenuProps } from './types';
import './menu.css';
import Sider from '../Sider';

const Menu:FC<MenuProps> = ({ user, items, logo, placement, width }) => {

    const [menuOpen, setMenuOpen] = useState(false);

    const openDrawer = () => {
        setMenuOpen(true);
    };

    const closeDrawer = () => {
        setMenuOpen(false);
    };

    return (
        <div className="menu">
            <Button
                style={{ paddingTop: 0, background: 'none', border: 0, color: '#0b4275', fontSize: '30px', boxShadow: '0' }}
                className="menu-button"
                onClick={openDrawer}>
                <MenuOutlined />
            </Button>
            <Drawer
                open={menuOpen}
                onClose={closeDrawer}
                placement={placement}
                width={width}>
                <Sider displayAsDiv />
            </Drawer>
        </div>
    );
};

export default Menu;
